var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-table',{ref:"table",attrs:{"actions":_vm.isUserInternalAdmin ? _vm.actions : []}})
}
var staticRenderFns = []

export { render, staticRenderFns }